export const InvalidRecipientsModal: string = 'InvalidRecipientsModal';
